import React from 'react'
import DocumentationSidebar from '../component/DocumentationSidebar'
import { useDocImage } from '../hooks/useDocImage';
import { useTranslation } from 'react-i18next';

export default function CreateSurvey() {
  const { t } = useTranslation();
  const image001 = useDocImage('create-survey-img', 'image001.png');
  const image002 = useDocImage('create-survey-img', 'image002.png');
  const image003 = useDocImage('create-survey-img', 'image003.png');
  const image004 = useDocImage('create-survey-img', 'image004.png');
  const image005 = useDocImage('create-survey-img', 'image005.png');
  const image006 = useDocImage('create-survey-img', 'image006.png');
  const image007 = useDocImage('create-survey-img', 'image007.png');

  return (
    <>
      <div className='d-flex flex-column main-outer-wrapper'>
        <div className="flex-grow-1 d-flex survey-main-wrapper">
          <DocumentationSidebar />

          {/* Dashboard Content */}
          <div className="flex-grow-1 dashboard-page-outer">
            <div className='dashboard-page-wrap document-page-wrap'>

              <h1 className='mt-0 text-primary'>{t('documentation.createSurvey.title')}</h1>
              <p className='header-para'>{t('documentation.createSurvey.intro')}</p>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.createSurvey.guide.title')}
                </div>
                <div className="card-body">
                  <p><b>{t('documentation.createSurvey.guide.steps.step1Title')}</b></p>
                  <ul>
                    <li>{t('documentation.createSurvey.guide.steps.step1Desc')}</li>
                    <img src={image001} alt={t('documentation.createSurvey.guide.imageAlt1')} className='img-fluid pt-20 pb-20' />
                  </ul>
                  <p><b>{t('documentation.createSurvey.guide.steps.step2Title')}</b></p>
                  <ul>
                    <li>{t('documentation.createSurvey.guide.steps.step2Desc')}</li>
                    <img src={image002} alt={t('documentation.createSurvey.guide.imageAlt2')} className='w-60 pt-20 pb-20' />
                  </ul>
                  <p><b>{t('documentation.createSurvey.guide.steps.step3Title')}</b></p>
                  <ul>
                    <li>{t('documentation.createSurvey.guide.steps.step3Desc')}</li>
                    <img src={image003} alt={t('documentation.createSurvey.guide.imageAlt3')} className='w-60 pt-20 pb-20' />
                  </ul>
                  <p><b>{t('documentation.createSurvey.guide.steps.step4Title')}</b></p>
                  <ul>
                    <li>{t('documentation.createSurvey.guide.steps.step4Desc')}</li>
                    <li>{t('documentation.createSurvey.guide.steps.step4Note')}</li>
                    <img src={image004} alt={t('documentation.createSurvey.guide.imageAlt4')} className='w-60 pt-20 pb-20' />
                  </ul>

                  <p><b>{t('documentation.createSurvey.guide.steps.step5Title')}</b></p>
                  <ul>
                    <li>{t('documentation.createSurvey.guide.steps.step5Desc')}</li>
                    <li>{t('documentation.createSurvey.guide.steps.step5Note')}</li>
                    <img src={image005} alt={t('documentation.createSurvey.guide.imageAlt5')} className='w-60 pt-20 pb-20' />
                  </ul>

                  <p><b>{t('documentation.createSurvey.guide.steps.step6Title')}</b></p>
                  <ul>
                    <li>{t('documentation.createSurvey.guide.steps.step6Desc1')}</li>
                    <li>{t('documentation.createSurvey.guide.steps.step6Desc2')}</li>
                    <li>{t('documentation.createSurvey.guide.steps.step6Note')}</li>
                    <img src={image006} alt={t('documentation.createSurvey.guide.imageAlt6')} className='w-60 pt-20 pb-20' />
                  </ul>

                  <p><b>{t('documentation.createSurvey.guide.steps.step7Title')}</b></p>
                  <ul>
                    <li>{t('documentation.createSurvey.guide.steps.step7Desc')}</li>
                    <img src={image007} alt={t('documentation.createSurvey.guide.imageAlt7')} className='img-fluid pt-20 pb-20' />
                  </ul>

                </div>
              </div>

            

            </div>
          </div>

        </div>
      </div>
    </>
  )
}
